import { ref, type Ref } from 'vue';

import type { FormApiErrorResult } from '~/utils/apiFieldErrors';

type SetFormErrors<TField extends string> = (
  _fields: Partial<Record<TField, string | undefined>>,
) => void;

export default function useFormApiErrors<TField extends string>(
  setErrors: SetFormErrors<TField>,
) {
  const formApiError: Ref<null | string> = ref(null);

  function clearFormApiError() {
    formApiError.value = null;
  }

  function applyFormApiErrors(
    error: unknown,
    resolve: (_err: unknown) => FormApiErrorResult<TField>,
  ): boolean {
    clearFormApiError();

    const { fieldErrors, formError } = resolve(error);

    if (Object.keys(fieldErrors).length > 0) {
      setErrors(fieldErrors);
    }

    if (formError) {
      formApiError.value = formError;
    }

    return Object.keys(fieldErrors).length > 0 || Boolean(formError);
  }

  return {
    applyFormApiErrors,
    clearFormApiError,
    formApiError,
  };
}
